import { render, staticRenderFns } from "./historicoAlteracoes.vue?vue&type=template&id=04c62e32&"
import script from "./historicoAlteracoes.vue?vue&type=script&lang=js&"
export * from "./historicoAlteracoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports